<template>
  <c-input-container
    class="c-select"
    v-bind="containerAttributes"
  >
    <c-select-raw
      ref="select"
      v-bind="$attrs"
      v-on="componentListeners"
    />
  </c-input-container>
</template>

<script>
import CInputContainer from '@convenia/components/CInputContainer'
import useVue3Migration from '@convenia/composables/useVue3Migration'
import CSelectRaw from './fragments/CSelectRaw.vue'

export default {
  name: 'CSelect',

  components: {
    CSelectRaw,
    CInputContainer
  },

  setup (_, ctx) {
    const { componentListeners } = useVue3Migration(ctx)
    return {
      componentListeners
    }
  },

  computed: {
    containerAttributes () {
      return {
        ...this.$attrs,
        name: this.name
      }
    }
  }
}
</script>
